import React from 'react';

const SACSection = ({ data, updateData }) => {
  const handleSACSelection = (sacId) => {
    const newSAC = data.selectedSAC === sacId ? '' : sacId;
    updateData({
      selectedSAC: newSAC,
      spaceType: '',
      roomType: ''
    });
  };

  const sacOptions = [
    {
      id: 'sac01',
      title: 'SAC01:',
      description: 'Building Element Footprint Components – Space taken by walls, columns, and other vertical elements that can\'t be occupied.'
    },
    {
      id: 'sac02',
      title: 'SAC02:',
      description: 'Interior Space Use Classifications – Usable or serviceable indoor spaces, grouped by function.'
    },
    {
      id: 'sac03',
      title: 'SAC03:',
      description: 'Exterior Space Use Classifications – Outdoor spaces, roofed or unroofed, attached to or around the building.'
    }
  ];

  return (
    <div className="card p-3">
      <h3 className="font-semibold mb-3">2.1. SPECIFIC AREA COMPONENTS (SAC)</h3>
      <p className="note mb-3">Only one can be chosen</p>
      <div className="grid gap-2">
        {sacOptions.map(option => (
          <label key={option.id} className="flex items-start gap-2">
            <input 
              type="radio" 
              name="sac"
              checked={data.selectedSAC === option.id} 
              onChange={() => handleSACSelection(option.id)} 
              className="mt-1" 
            />
            <span>
              <strong>{option.title}</strong> {option.description}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default SACSection;